var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomerPrivateMan2 = function SvgCustomerPrivateMan2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.011 150",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#135899",
    d: "m52.706 117.615-22.355 12.198a19.8 19.8 0 0 0-3.595 2.576 74.94 74.94 0 0 0 96.225.255 20 20 0 0 0-3.938-2.661l-23.915-11.972a9.17 9.17 0 0 1-5.038-8.179v-9.4a34 34 0 0 0 2.261-2.83 54.8 54.8 0 0 0 7.444-15.029 7.5 7.5 0 0 0 5.356-7.157v-10.1a7.53 7.53 0 0 0-2.518-5.661v-14.35s2.825-22.643-27.599-22.643S47.44 45.305 47.44 45.305v14.438a7.53 7.53 0 0 0-2.518 5.661v10.019a7.61 7.61 0 0 0 3.48 6.34 50 50 0 0 0 9.085 18.764v9.169a9.11 9.11 0 0 1-4.783 7.924Z",
    "data-name": "Pfad 301"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#adcce9",
    d: "M76.45.02a74.943 74.943 0 0 0-49.668 132.339 19.6 19.6 0 0 1 3.538-2.518l22.387-12.226a9.09 9.09 0 0 0 4.755-8.009v-9.169a49.7 49.7 0 0 1-9.059-18.794 7.44 7.44 0 0 1-3.48-6.312V65.312a7.53 7.53 0 0 1 2.518-5.668V45.303s-2.975-22.642 27.594-22.642 27.6 22.642 27.6 22.642v14.438a7.5 7.5 0 0 1 2.49 5.661V75.42a7.5 7.5 0 0 1-5.322 7.161 56 56 0 0 1-7.448 15.03 26 26 0 0 1-2.263 2.83v9.4a9.17 9.17 0 0 0 5.043 8.179l23.966 11.965a20.8 20.8 0 0 1 3.934 2.621A75 75 0 0 0 76.45.02",
    "data-name": "Pfad 302"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomerPrivateMan2);
export default ForwardRef;